/**
 * Máscara só de exibição. 10 dígitos (DDD+8, sem o 9 extra) → (XX) XXXX-XXXX.
 * Não insere 9 e não altera o valor enviado.
 */
import { useFormatter } from "@/utils/useFormatter";

export function formatEcommercePhoneDisplay(phone: string): string {
  const trimmed = String(phone ?? "").trim();
  if (!trimmed) return "";

  const digits = trimmed.replace(/\D/g, "");
  const local =
    digits.startsWith("55") && digits.length >= 12
      ? digits.slice(2)
      : digits;

  if (local.length === 10) {
    return local.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }

  return useFormatter.formatPhoneNumber(trimmed) || trimmed;
}
